import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import OtherUserGroupModel from "@/commons/models/OtherUserGroup";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 施設関係者グループ種類にひもづくメンバー API 操作クラス
 */
export default class OtherUserGroupTypeMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserGroupMembers
   */
  public async get(userStore: LoginUser, typeId: number): Promise<Array<OtherUserGroupTypeGroup>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      typeId: typeId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupTypeMembers, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserGroupTypeGroup>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface OtherUserGroupTypeGroup extends OtherUserGroupModel {
  groupName?: string;
  /** モーダル表示可否 */
  show: boolean;
  members: Array<OtherUserGroupTypeMember>;
}

export interface OtherUserGroupTypeMember extends OtherUserGroupModel {
  isTarget: boolean;
  /** モーダル表示可否 */
  show: boolean;
  groupTypeName: string;
}
